<template>
  <ontick-div
    class="fixed inset-0 overflow-y-auto"
    style="z-index: 5000"
    v-show="open"
  >
    <ontick-div
      class="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0"
    >
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ontick-div v-if="open" class="h-screen w-screen">
          <ontick-div
            @click.native="$emit('close')"
            class="fixed inset-0 transition-opacity"
          >
            <ontick-div
              class="absolute inset-0 bg-gray-900 opacity-75"
            ></ontick-div>
          </ontick-div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:h-screen sm:align-middle"
          ></span
          >&#8203;

          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <!-- Default: w-2/4 -->
            <!-- Modificado: w-3/4 -->
            <ontick-div
              v-if="open"
              :class="[
                sizeModal,
                'bg-ontick-graphite-500 inline-block transform rounded-lg p-0 text-left align-bottom shadow transition-all sm:my-8 sm:align-middle',
              ]"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <ontick-div>
                <ontick-div>
                  <slot></slot>
                </ontick-div>
                <slot name="footer"></slot>
              </ontick-div>
            </ontick-div>
          </transition>
        </ontick-div>
      </transition>
    </ontick-div>
  </ontick-div>
</template>

<script>
export default {
  name: "base-modal-setting",
  props: {
    title: {
      type: String,
    },
    open: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "normal",
      validator: function (value) {
        return ["small", "normal", "large"].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    sizeModal() {
      return {
        "2xl:w-1/4 xl:w-2/4 lg:w-2/4 md:w-2/4 sm:w-2/4": this.size == "small",
        "w-2/4": this.size == "normal",
        "w-3/4": this.size == "large",
      };
    },
  },
};
</script>
